import axios from './axios'

export function getAllDoctors(options){
    // return axios.get('/api/v1/web/japan_treatment/doctor_list' ,options,{indices: false})
    return axios.get('/api/v1/web/japan_treatment/doctor_list?page=' + options.page + '&state_id=' + options.state_id + '&disease_id=' + options.disease_id)
}

export function getDoctorInfo(options){
    return axios.get('/api/v1/web/japan_treatment/doctor_info?id=' + options.id);
}